export default __webpack_public_path__ + "static/worker1-23ca72e369be3ebd1e35c744488ad0b9.jpg";